export function testStorage() {
    try {
        window?.localStorage?.getItem('')
    } catch (e) {
        return false
    }
    return true
}